import { render, staticRenderFns } from "./BuscarChamados.vue?vue&type=template&id=0d090f08&scoped=true"
import script from "./BuscarChamados.vue?vue&type=script&lang=js"
export * from "./BuscarChamados.vue?vue&type=script&lang=js"
import style0 from "./BuscarChamados.vue?vue&type=style&index=0&id=0d090f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d090f08",
  null
  
)

export default component.exports